var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/nam.phamanh/Documents/Nam/git/cs/lazada/node_modules/_nunjucks-loader@2.4.9@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/baseui/templates/frame.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["name"], 
[], 
function (l_name, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("name", l_name);
var t_2 = "";t_2 += "\n<div class=\"alime-header _block -dark-blue\" id=\"alime-header\">\n  <div class=\"alime-header _back\" id=\"alime-header-back-button\" role=\"button\" aria-label=\"back\">\n    <span class=\"alime-header _back-arrow\">Back</span>\n  </div>\n  <div class=\"alime-header _close\" id=\"alime-header-close-button\" role=\"button\" aria-label=\"close\"></div>\n  <div class=\"alime-header _bot-name\" id=\"alime-header-name\">";
t_2 += runtime.suppressValue(l_name, env.opts.autoescape);
t_2 += "</div>\n</div>\n<div class=\"m-alicare-body\" id=\"alime-body\">\n  <div class=\"m-alicare-scroller\" tabindex=\"-1\">\n  </div>\n</div>\n<div class=\"alime-footer _block\" id=\"alime-footer\"></div>\n<div class=\"end-conversation-holder _block -hidden\" id=\"end-conversation-holder\"></div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("base");
context.setVariable("base", macro_t_1);
output += "\n\n";
var macro_t_3 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_4 = "";t_4 += "\n<div id=\"alime-shortcuts-wrapper\"></div>\n<div class=\"alime-input _form-wrapper\" id=\"alime-input-form-wrapper\">\n  <div class=\"alime-input _form\" id=\"alime-input-form\"></div>\n</div>\n<div class=\"alime-plugins _wrapper\" id=\"alime-plugins-wrapper\">\n  <div class=\"alime-plugins _content\" id=\"alime-plugins\"></div>\n</div>\n<div class=\"csc-plugins-popup _block -agent\" id=\"csc-plugins-popup\">\n  <div class=\"csc-plugins-popup _item-wrapper\">\n    <div class=\"csc-plugins-popup _item \">\n      <label class=\"csc-camera-button _block\">\n        <input class=\"csc-camera-button _input\"\n          type=\"file\"\n          accept=\"image/*\"\n          capture=\"camera\"\n        />\n      </label>\n    </div>\n    <div class=\"csc-plugins-popup _item\">\n      <label class=\"csc-upload-button _block\">\n        <input\n          class=\"csc-upload-button _input\"\n          type=\"file\"\n          accept=\"image/*\"\n        />\n      </label>\n    </div>\n    <div class=\"csc-plugins-popup _item\">\n        <label class=\"csc-attach-button _block\">\n          <input\n            class=\"csc-attach-button _input\"\n            type=\"file\"\n            accept=\".xlsx,.xls,.doc,.docx,.pdf\"\n          />\n        </label>\n      </div>\n  </div>\n</div>\n\n\n";
;
frame = callerFrame;
return new runtime.SafeString(t_4);
});
context.addExport("footer");
context.setVariable("footer", macro_t_3);
output += "\n\n";
var macro_t_5 = runtime.makeMacro(
["send"], 
[], 
function (l_send, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("send", l_send);
var t_6 = "";t_6 += "\n  <div class=\"alime-input _message-wrapper\" id=\"alime-message-wrapper\">\n    <div class=\"panel J_Panel\">\n      <div class=\"alime-input _panel-wrapper\">\n          <div class=\"alime-input _plugin-toggle\">\n            <div class=\"csc-plugin-toggle _button\" id=\"csc-plugin-toggle\">\n              <i class=\"csc-plugin-toggle _icon\"></i>\n            </div>\n          </div>\n          <div class=\"alime-input _text-wrapper\" id=\"alime-input-text-wrapper\">\n            <textarea placeholder=\"\" class=\"alime-input _message textarea J_Field\" id=\"alime-text-input\"></textarea>\n            <textarea class=\"alime-input _message textarea-copy J_InputFieldCopy -message\" id=\"alime-text-copy-input\"></textarea>\n            <input type=\"number\" class=\"alime-input _message input J_NumberField -message\" id=\"alime-number-input\" />\n            <div class=\"alime-input _emoji-opener \" id=\"alime-emoji-opener\">\n              <i class=\"iconfont icon-emoji\"></i>\n            </div>\n          </div>\n      </div>\n    </div>\n  </div>\n  <!-- SEND BUTTON -->\n  <div class=\"alime-input _send-button\" id=\"alime-send-button\">\n    <div class=\"alime-input _send\" id=\"alime-send-arrow\">";
t_6 += runtime.suppressValue(l_send, env.opts.autoescape);
t_6 += "</div>\n  </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_6);
});
context.addExport("input");
context.setVariable("input", macro_t_5);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/baseui/templates/frame.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/component/baseui/templates/frame.html
// module id = 178
// module chunks = 0 1